// import React, { useState, useEffect } from "react";
// import BigAdd from './BigAdd'
// import DharamSanchar2 from './DharamSanchar2'
// import axios from "axios";
// import BollywoodNews2 from "./BollywoodNews2";
// import InternationalDetails2 from "./InternationalDetails2";
// import { Circles } from "react-loader-spinner";
// import { Helmet, HelmetProvider } from 'react-helmet-async';


// // import './style1.css';

// const baseUrl = "https://api.shabdtoday.com/";
// const image_resize = "https://api.shabdtoday.com/api/home/resize";
// const truncateText = (text, maxLength) => {
//   if (text.length > maxLength) {
//     return text.substring(0, maxLength);
//   }
//   return text;
// };

// const stripHtmlTags = (html, maxLength) => {
//   const tempDiv = document.createElement("div");
//   tempDiv.innerHTML = html;
//   const strippedText = tempDiv.textContent || tempDiv.innerText || "";
//   return truncateText(strippedText, maxLength);
// };


// const online ="https://api.shabdtoday.com/api/home/dharams"
// const local = "https://localhost:44351/api/home/dharams"

// function DaramDetails() {
//   const [postData, setPostData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(online);
//         setPostData(response.data);
//         setLoading(false);
//       } catch (error) {
//         setError(error.message);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);


//   const formatDateInHindi = (dateString) => {
//     const date = new Date(dateString);
//     const monthsInHindi = [
//       "जनवरी",
//       "फरवरी",
//       "मार्च",
//       "अप्रैल",
//       "मई",
//       "जून",
//       "जुलाई",
//       "अगस्त",
//       "सितंबर",
//       "अक्टूबर",
//       "नवंबर",
//       "दिसंबर",
//     ];
//     const seconds = date.getSeconds();
//     const minute = date.getMinutes();
//     var hour = date.getHours();
//     const day = date.getDate();
//     const month = monthsInHindi[date.getMonth()];
//     const year = date.getFullYear();
//     const amPm = hour >= 12 ? "PM" : "AM";
//     hour = hour % 12 || 12;
//     return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
//   };

//   const generateShareLinks = (mainKhabarId, newsHeading) => {
//     const encodedNewsHeading = encodeURIComponent(newsHeading);
//     const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
//     return {
//       facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedNewsHeading}`,
//       whatsapp: `https://api.whatsapp.com/send?text=${encodedNewsHeading} ${url}`,
//       twitter: `https://twitter.com/intent/tweet?text=${encodedNewsHeading}&url=${url}`,
//       instagram: `https://www.instagram.com/`
//     };
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         {/* <Circles
//           height="30"
//           width="30"
//           color="#f7265c"
//           ariaLabel="circles-loading"
//           wrapperStyle={{}}
//           wrapperClass=""
//           visible={true}
//         /> */}
//       </div>
//     );
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div>
//       <div className="ak-post-wrapper" style={{ transform: "none" }}>
//         <div
//           className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix"
//           style={{ transform: "none" }}
//         >
//           <div className="ak-container" style={{ transform: "none" }}>
//             <div className="ak-content" style={{ transform: "none" }}>
//               <div className="" style={{ transform: "none" }}>
//                 <div className='mt-2'>
//                   <BigAdd />
//                 </div>

//                 <div className="row" style={{ transform: "none" }}>

//                   <div className="ak_column_1 col-md-9">
//                     <div className="ak-article-inner">

//                       <div className=''>
//                         <div className="ak-block-header ak-block-header-style-5 no-tabs">
//                           <div>
//                             <h1 className='head' style={{ color: 'crimson', marginLeft: 10 }}>
//                               धर्म
//                             </h1>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className='mt-2'>
//                       <DharamSanchar2 />
//                     </div>
//                   </div>
//                   <div
//                     className="ak_column_ col-md-3  sidebar-column sidebar-column-primary-right sticky-sidebar"
//                     style={{
//                       position: "relative",
//                       overflow: "visible",
//                       boxSizing: "border-box",
//                       minHeight: 1
//                     }}
//                   >
//                     <div
//                       className="theiaStickySidebar"
//                       style={{
//                         paddingTop: 0,
//                         paddingBottom: 1,
//                         position: "sticky",
//                         transform: "none",
//                         top: 0,
//                         left: "914.5px"
//                       }}
//                     >
//                       <div className="sidebar post-sidebar">
//                       <BollywoodNews2 />
//                       <InternationalDetails2 />
//                         {/* <DhamSansar />
//                         <EkaDashi />

//                         <LifeSeince />
//                         <RashifalSmall /> */}


//                       </div>
//                       <div
//                         className="resize-sensor"
//                         style={{
//                           position: "absolute",
//                           inset: 0,
//                           overflow: "hidden",
//                           zIndex: -1,
//                           visibility: "hidden"
//                         }}
//                       >
//                         <div
//                           className="resize-sensor-expand"

//                           style={{
//                             position: "absolute",
//                             left: 0,
//                             top: 0,
//                             right: 0,
//                             bottom: 0,
//                             overflow: "hidden",
//                             zIndex: -1,
//                             visibility: "hidden"
//                           }}
//                         >
//                           <div
//                             style={{
//                               position: "absolute",
//                               left: 0,
//                               top: 0,
//                               transition: "all 0s ease 0s",
//                               width: 410,
//                               height: 1260
//                             }}
//                           />
//                         </div>
//                         <div
//                           className="resize-sensor-shrink"
//                           style={{
//                             position: "absolute",
//                             left: 0,
//                             top: 0,
//                             right: 0,
//                             bottom: 0,
//                             overflow: "hidden",
//                             zIndex: -1,
//                             visibility: "hidden"
//                           }}
//                         >
//                           <div
//                             style={{
//                               position: "absolute",
//                               left: 0,
//                               top: 0,
//                               transition: "0s",
//                               width: "200%",
//                               height: "200%"
//                             }}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//               </div>
//             </div>

//           </div>
//         </div>

//       </div>


//     </div>
//   )
// }

// export default DaramDetails

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { Helmet } from "react-helmet";

const baseUrl = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

// ✅ Responsive check
const isDesktopScreen = () => window.innerWidth >= 1024;

// ✅ Utility functions
const truncateText = (text, maxLength) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      if (charCount >= maxLength && !isTruncated) {
        isTruncated = true;
        newNode = document.createTextNode(truncated + "...");
      } else {
        newNode = document.createTextNode(truncated);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) {
          newNode.appendChild(traverse(child));
        }
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};

const online = "https://api.shabdtoday.com/api/home/tajaKhabars";
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount";

// ✅ Strip HTML tags for plain text
const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const DharamSanchar2 = () => {
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  // ✅ Fetch ताज़ा खबरें (API)
  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=5`);
      const data = response.data?.tazaKhabars || [];

      if (data.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = data.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching TazaKhabars:", error.message);
      setError("ताज़ा खबरें लोड करने में समस्या हुई।");
    } finally {
      setFetching(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);

  const renderHtmlContent = (html) => {
    const sanitizedHtml = DOMPurify.sanitize(html);
    return { __html: sanitizedHtml };
  };

  // ✅ Update View Count + Redirect
  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(clickonline, { mainKhabarId });
      if (response.status === 200) {
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count");
      }
    } catch (error) {
      console.error("Error updating view count:", error.message);
    }
  };

  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodednewsTag = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodednewsTag}&url=${url}`,
    };
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <Helmet>
        <title>धर्म न्यूज़ – धार्मिक खबरें, पूजा-पाठ, पर्व व आध्यात्मिक लेख | ShabdToday</title>

        <meta name="title" content="आज की ताज़ा धार्मिक खबरें – देश-दुनिया की आध्यात्मिक हलचलें और पवित्र अपडेट हिंदी में!" />
        <meta name="description" content="धर्म, आस्था और अध्यात्म की हर बड़ी खबर अब एक ही जगह! ShabdToday पर पढ़ें आज की ताज़ा धार्मिक खबरें, देश-दुनिया के पवित्र स्थलों, आध्यात्मिक यात्राओं और तीर्थस्थलों से जुड़ी सबसे विश्वसनीय अपडेट — वो भी सरल और भावनात्मक हिंदी में।" />
        <meta name="keywords" content="धार्मिक खबरें हिंदी में, आज की धार्मिक खबरें, आध्यात्मिक समाचार, हिंदू धर्म अपडेट, तीर्थस्थल समाचार, धार्मिक यात्रा अपडेट, देश दुनिया की धार्मिक खबरें, धर्म समाचार हिंदी, ShabdToday धार्मिक खबरें" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />

        <link rel="canonical" href="https://shabdtoday.com/Daram-News" />

        <meta property="og:title" content="धर्म न्यूज़ – पूजा-पाठ व धार्मिक अपडेट | ShabdToday" />
        <meta property="og:description" content="पूजा-पाठ, धार्मिक परंपराओं और त्योहारों की खबरें हिंदी में।" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shabdtoday.com/Daram-News" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/Daram-cover.webp" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Dharam News – ShabdToday",
            "url": "https://shabdtoday.com/Daram-News",
            "description": "धार्मिक खबरें, पूजा-पाठ और आध्यात्मिक लेख हिंदी में।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script>

        <h1 style={{ color: "crimson", marginLeft: 10 }}>धर्म से जुड़ी ताज़ा खबरें</h1>
        <h2 style={{ marginLeft: 10 }}>पूजा-पाठ, पर्व-त्योहार और आध्यात्मिक लेख</h2>
        <h3 style={{ marginLeft: 10 }}>रोज़ाना धार्मिक अपडेट हिंदी में</h3>
      </Helmet>

      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_65f7f61f36732_2"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const htmlContent = isDesktop
                        ? truncateHtml(post.newsTag, 100)
                        : post.newsTag;

                      return (
                        <article
                          key={post.mainKhabarId}
                          className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix"
                        >
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">
                              <div className="ak-module-details mb-3">
                                <h1 className="ak-module-title">
                                  <Link
                                    to={`/News-Details/${post.slug}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleNewsClick2(post.slug, post.mainKhabarId);
                                    }}
                                    rel="bookmark"
                                    title={stripHtmlTags(post.newsTag)}
                                  >
                                    <span
                                      className="responsive-font"
                                      style={{ lineHeight: "30px" }}
                                      dangerouslySetInnerHTML={{ __html: htmlContent }}
                                    />
                                  </Link>
                                </h1>
                              </div>
                              <div className="ak-featured-cover">
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNewsClick2(post.slug, post.mainKhabarId);
                                  }}
                                  className="ak-featured-link"
                                  title={stripHtmlTags(post.newsTag)}
                                >
                                  <div className="ak-featured-thumb  size-500">
                                    <img
                                      fetchpriority="high"
                                      decoding="async"
                                      width={600}
                                      height={300}
                                      loading="lazy"
                                      src={baseUrl + post.newsImage}
                                      className="attachment-newsy_360x180 size-newsy_360x180 lazyload wp-post-image"
                                      alt={stripHtmlTags(post.newsTag, 150)}
                                    />
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                          <hr />
                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>Loading more news...</p>}
        {!hasMore && <p>No more news available.</p>}
      </div>
    </div>
  );
};

export default DharamSanchar2;